import Vue from "vue";
import App from "./App.vue";
import router from "./pages/router";
import store from "@/store";
import { directive as onClickOutside } from 'vue-on-click-outside' ;
import TextareaAutosize from 'vue-textarea-autosize';
import {format, parse} from 'date-fns';
import vSelect from 'vue-select';
import { Laue } from 'laue';
import Toasted from 'vue-toasted';
import axios from "axios";

Vue.config.productionTip = false;

Vue.directive('on-click-outside', onClickOutside);

Vue.use(TextareaAutosize);
Vue.use(Laue);
Vue.use(Toasted);

Vue.filter('date', function(value) {
  var d = parse(value, 'yyyy-MM-dd', new Date());
  if (value) {
      return format(d, 'MM/dd/yyyy');
  }
});

Vue.filter('simple_date', function(value) {
	var d = parse(value, 'yyyy-MM-dd', new Date());
	if (value) {
		return format(d, 'M/dd/yy');
	}
  });

Vue.filter('detailed_date', function(value) {
  var d = parse(value, 'yyyy-MM-dd HH:mm:s', new Date());
  if (value) {
      return format(d, 'MM/dd/yyyy h:mm a');
  }
});

Vue.component('v-select', vSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");